import { createReducer, on } from '@ngrx/store';
import { logoutSuccess } from 'src/app/core/store/user/user.actions';
import * as EventsActions from './events.actions';
import { initialState } from './events.state';

export const eventsReducer = createReducer(
  initialState,

  on(logoutSuccess, () => initialState),

  on(EventsActions.loadEvents, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(EventsActions.loadEventsSuccess, (state, { events }) => ({
    ...state,
    items: events,
    loading: false,
    error: null,
  })),

  on(EventsActions.loadEventsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
